export renderElement from './element';
export renderDiv from './div';
export renderSpan from './span';
export renderButton from './button';
export renderImage from './image';
export renderLi from './li';
export renderUl from './ul';
export renderStyle from './style';
export renderStrong from './strong';
export renderPre from './pre';
export renderH3 from './h3';



// WEBPACK FOOTER //
// ../~/idom-util/src/index.js